import { Badge, Box, IconButton, Tooltip } from "@material-ui/core";
import { ClearOutlined, FilterListOutlined } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { useBookingKitSearchFilters } from "../hooks/use-booking-kit-search-filters";
import { SortFilter } from "@bonliva-crm/ui/search-filters";

export function BookingKitTopBar() {
  const {
    hasValues,
    filterManager: { setFilterSliderOpen, resetFilters }
  } = useBookingKitSearchFilters();

  const sortOptions = [
    {
      value: "createdOn_asc",
      label: locale.asc(locale.Created)
    },
    {
      value: "createdOn_desc",
      label: locale.desc(locale.Created)
    },
    {
      value: "bookingDate_asc",
      label: locale.asc(locale.Week)
    },
    {
      value: "bookingDate_desc",
      label: locale.desc(locale.Week)
    },
    {
      value: "timereportCreatedOn_asc",
      label: locale.asc(locale.TimeReport)
    },
    {
      value: "timereportCreatedOn_desc",
      label: locale.desc(locale.TimeReport)
    },
    {
      value: "timereportApprovedOn_asc",
      label: locale.asc(`${locale.TimeReport} ${locale.Approved}`)
    },
    {
      value: "timereportApprovedOn_desc",
      label: locale.desc(`${locale.TimeReport} ${locale.Approved}`)
    }
  ];

  return (
    <>
      <Box style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}>
        <Tooltip title={locale.AllFilters}>
          <IconButton onClick={() => setFilterSliderOpen(true)}>
            <Badge color="primary" variant="dot" invisible={!hasValues}>
              <FilterListOutlined />
            </Badge>
          </IconButton>
        </Tooltip>

        <Tooltip title={locale.resetFilters}>
          <IconButton onClick={resetFilters}>
            <ClearOutlined />
          </IconButton>
        </Tooltip>

        <SortFilter name={"sort"} options={sortOptions} />
      </Box>
    </>
  );
}
